module.exports = __webpack_public_path__ + "static/Dash_reels-3aaaab00c72588f5a0f6948f2049219a.png";